import ApiServer from '@/utils/api/ApiServer.js'
const paths = (includeInUse, includeArchived, includeAvailable, includePageNumbers, pageNumbers) => {
  return {
    getAll: ApiServer.urlFor('ticketBooks', {
      version: 1,
      params: {
        includeInUse,
        includeArchived,
        includeAvailable,
        includePageNumbers,
        pageNumbers: pageNumbers.join(',')
      }
    })
  }
}

export default {
  async fetchTicketBooks (context, { includeInUse = false, includeArchived = false, includeAvailable = true, includePageNumbers = true, pageNumbers = [] }) {
    try {
      context.commit('setLoading', true)
      const path = paths(includeInUse, includeArchived, includeAvailable, includePageNumbers, pageNumbers).getAll
      const response = await ApiServer.get(path)
      context.commit('setTicketBooks', response.data)
      return response.data
    } finally {
      context.commit('setLoading', false)
    }
  },

  async fetchTicketBooksOverlap (_) {
    const response = await ApiServer.get('ticketbooks/overlap')
    return response.data
  }
}
